import { render, staticRenderFns } from "./demand.vue?vue&type=template&id=71b333f1&scoped=true"
import script from "./demand.vue?vue&type=script&lang=js"
export * from "./demand.vue?vue&type=script&lang=js"
import style0 from "./demand.vue?vue&type=style&index=0&id=71b333f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b333f1",
  null
  
)

export default component.exports